import { render, staticRenderFns } from "./loginCallback.vue?vue&type=template&id=56272ee4&scoped=true&"
import script from "./loginCallback.vue?vue&type=script&lang=js&"
export * from "./loginCallback.vue?vue&type=script&lang=js&"
import style0 from "./loginCallback.vue?vue&type=style&index=0&id=56272ee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56272ee4",
  null
  
)

export default component.exports